import React from 'react';
import {IMultiSelectProps, ISelectProps, MultiSelectInput, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {fetchSupplyPackages} from '~/modules/Pmp/api';

type ISelectSupplyPackageProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectSupplyPackage = ({
    disabled,
    ...props
}: ISelectSupplyPackageProps) => {
    const {resource, isPending} = useResource(() => fetchSupplyPackages(), []);

    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(resource.map(supplyPackage => ({
            label: supplyPackage.name,
            value: supplyPackage.id
        })), 'label', TableSortDirection.ASC)}/>;
};

export const SelectSupplyPackageField = (props: IFieldProps<ISelectSupplyPackageProps>) => <FormField {...props}>
    <SelectSupplyPackage {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
